export function merge(current, next, depth = -1) {
  // next is missing, return current state
  if (next === undefined) return current;

  // current is missing, return next state
  if (current === undefined) return next;

  const currentType = typeof current;
  const nextType = typeof next;

  // only same types should be merged
  const isSameType = currentType === nextType;

  // only plain objects should be merged
  const isPlainObject =
    nextType === 'object' &&
    current !== null &&
    next !== null &&
    !Array.isArray(next);

  // do not merge if type has changed, object is not mergable, or
  // depth limit has been reached
  if (!isSameType || !isPlainObject || depth === 0) return next;

  return Array.from(
    new Set([...Object.keys(current), ...Object.keys(next)])
  ).reduce(function mergeReducer(o, k) {
    return {
      ...o,
      [k]: merge(current[k], next[k], --depth)
    };
  }, {});
}

export default merge;



// WEBPACK FOOTER //
// ./js/util/merge.js